// Accordion
jQuery(function() {
  var acSubmenu = document.querySelectorAll(".ac_submenu");
  for (var i = 0; i < acSubmenu.length; i++) {
    acSubmenu[i].style.display = "none";
  }

  var Accordion = function(el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;

    // Variables privadas
    var links = this.el.find(".ac_link");

    // Evento
    links.on("click", { el: this.el, multiple: this.multiple }, this.dropdown);
  };

  Accordion.prototype.dropdown = function(e) {
    var $el = e.data.el;
    ($this = jQuery(this)), ($next = $this.next());
    $next.slideToggle();
    $this.parent().toggleClass("ac_open");
    // console.log($this);
    $this
      .attr("aria-expanded", "true")
      .next()
      .attr("aria-hidden", "false");

    if (!e.data.multiple) {
      $el
        .find(".ac_submenu")
        .not($next)
        .slideUp()
        .parent()
        .removeClass("ac_open");
    }
  };
  var accordion = new Accordion(jQuery(".ac_accordion"), false);
  //To make only 1 Panel open, keep second parameter false
});
jQuery(document).ready(function() {
  jQuery(".ac_accordion").on("keypress", "li", function(e) {
    if (e.keyCode == 13 || e.keyCode == 32) {
      jQuery(this)
        .find(".ac_link")
        .trigger("click");
      e.preventDefault();
    }
  });
});

jQuery(document).ready(function() {
  if (jQuery(window).width() < 992) {
    jQuery("#primary-menu li a").attr("tabindex", "-1");

    jQuery('input[type = "checkbox"]').on("keypress", function(event) {
      if (event.which === 13 || event.which === 32) {
        this.checked = !this.checked;

        if (jQuery(".site-header .menu-btn").is(":checked")) {
          jQuery("#primary-menu li a").attr("tabindex", "0");
        } else {
          jQuery("#primary-menu li a").attr("tabindex", "-1");
        }
      }
    });
  }
  // adding code for sorting gcs accordian
  function sortListDirWithH() {
  var list, i, switching, b, shouldSwitch, dir, switchcount = 0;
  list = document.getElementById("ac_accordion");
  switching = true;
  // Set the sorting direction to ascending:
  dir = "asc"; 
  // Make a loop that will continue until no switching has been done:
  while (switching) {
    // start by saying: no switching is done:
    switching = false;
     //check if accordion exist
    if(list != null) 
    {
      b = list.getElementsByTagName("LI");
      // Loop through all list-items:
      for (i = 0; i < (b.length - 1); i++) {
        //start by saying there should be no switching:
        shouldSwitch = false;
        /* check if the next item should switch place with the current item,
        based on the sorting direction (asc or desc): */
        if (dir == "asc") {
          if (b[i].querySelector("h3").innerHTML.toLowerCase() > b[i + 1].querySelector("h3").innerHTML.toLowerCase()) {
            /* if next item is alphabetically lower than current item,
            mark as a switch and break the loop: */
            shouldSwitch = true;
            break;
          }
        } else if (dir == "desc") {       if(b[i].querySelector("h3").innerHTML.toLowerCase() < b[i + 1].querySelector("h3").innerHTML.toLowerCase()) {
            /* if next item is alphabetically higher than current item,
            mark as a switch and break the loop: */
            shouldSwitch= true;
            break;
          }
        }
      }

    }
   
    if (shouldSwitch) {
      /* If a switch has been marked, make the switch
      and mark that a switch has been done: */
      b[i].parentNode.insertBefore(b[i + 1], b[i]);
      switching = true;
      // Each time a switch is done, increase switchcount by 1:
      switchcount ++;
    } else {
      /* If no switching has been done AND the direction is "asc",
      set the direction to "desc" and run the while loop again. */
      if (switchcount == 0 && dir == "asc") {
        dir = "desc";
        switching = true;
      }
    }
  }
}


function sortListDirWithGrade() {
  var list, i, switching, b, shouldSwitch, dir, switchcount = 0;
  list = document.getElementById("ac_accordion");
  switching = true;
  // Set the sorting direction to ascending:
  dir = "asc"; 
  // Make a loop that will continue until no switching has been done:
  while (switching) {
    // start by saying: no switching is done:
    switching = false;
    //check if accordion exist
    if(list != null) 
    {
      b = list.getElementsByTagName("LI");
    // Loop through all list-items:
    for (i = 0; i < (b.length - 1); i++) {
      //start by saying there should be no switching:
      shouldSwitch = false;
      /* check if the next item should switch place with the current item,
      based on the sorting direction (asc or desc): */
      if (dir == "asc") {
        if (b[i].querySelector(".grade").innerHTML.toLowerCase() > b[i + 1].querySelector(".grade").innerHTML.toLowerCase()) {
          /* if next item is alphabetically lower than current item,
          mark as a switch and break the loop: */
          shouldSwitch = true;
          break;
        }
      } else if (dir == "desc") {       if(b[i].querySelector(".grade").innerHTML.toLowerCase() < b[i + 1].querySelector(".grade").innerHTML.toLowerCase()) {
          /* if next item is alphabetically higher than current item,
          mark as a switch and break the loop: */
          shouldSwitch= true;
          break;
        }
      }
    }
    }
    
    if (shouldSwitch) {
      /* If a switch has been marked, make the switch
      and mark that a switch has been done: */
      b[i].parentNode.insertBefore(b[i + 1], b[i]);
      switching = true;
      // Each time a switch is done, increase switchcount by 1:
      switchcount ++;
    } else {
      /* If no switching has been done AND the direction is "asc",
      set the direction to "desc" and run the while loop again. */
      if (switchcount == 0 && dir == "asc") {
        dir = "desc";
        switching = true;
      }
    }
  }
}



function sortListDirWithDate() {
  var list, i, switching, b, shouldSwitch, dir, switchcount = 0;
  list = document.getElementById("ac_accordion");  
  switching = true;
  // Set the sorting direction to ascending:
  dir = "asc"; 
  // Make a loop that will continue until no switching has been done:
  while (switching) {
    // start by saying: no switching is done:
    switching = false;
     //check if accordion exist
    if(list != null) 
    {
      b = list.getElementsByTagName("LI");
    // Loop through all list-items:
      for (i = 0; i < (b.length - 1); i++) {
        //start by saying there should be no switching:
        shouldSwitch = false;
        /* check if the next item should switch place with the current item,
        based on the sorting direction (asc or desc): */
        if (dir == "asc") {
          var xd = new Date(b[i].querySelector(".date").innerHTML.toLowerCase());
          var yd = new Date(b[i + 1].querySelector(".date").innerHTML.toLowerCase());
          if (xd > yd) {
            /* if next item is alphabetically lower than current item,
            mark as a switch and break the loop: */
            shouldSwitch = true;
            break;
          }
        } else if (dir == "desc") { 
          var xdd = new Date(b[i].querySelector(".date").innerHTML.toLowerCase());
          var ydd = new Date(b[i + 1].querySelector(".date").innerHTML.toLowerCase());
                if(xdd < ydd) {
            /* if next item is alphabetically higher than current item,
            mark as a switch and break the loop: */
            shouldSwitch= true;
            break;
          }
        }
      }
    }
    
    if (shouldSwitch) {
      /* If a switch has been marked, make the switch
      and mark that a switch has been done: */
      b[i].parentNode.insertBefore(b[i + 1], b[i]);
      switching = true;
      // Each time a switch is done, increase switchcount by 1:
      switchcount ++;
    } else {
      /* If no switching has been done AND the direction is "asc",
      set the direction to "desc" and run the while loop again. */
      if (switchcount == 0 && dir == "asc") {
        dir = "desc";
        switching = true;
      }
    }
  }
}

// sortListDirWithH();

//calling function to start
setdefaultSOrtToDate();

//function to set the default sort to date
function setdefaultSOrtToDate()
{
  sortListDirWithDate(); //First time sort
  jQuery('.sort_date').find('span').toggleClass('sorting_chevron-up'); //toggle the arrow
  jQuery('.sort_date').find('span').toggleClass('sorting_chevron-down'); //provide alternate for other toggles
}

jQuery('.sorting_accordance').on('click','.sort_vacancy',function(){
  jQuery(this).find('span').toggleClass('sorting_chevron-down');
  jQuery(this).find('span').toggleClass('sorting_chevron-up');
  sortListDirWithH();
});
jQuery('.sorting_accordance').on('click','.sort_grade',function(){
  jQuery(this).find('span').toggleClass('sorting_chevron-down');
  jQuery(this).find('span').toggleClass('sorting_chevron-up');
  sortListDirWithGrade();
});
jQuery('.sorting_accordance').on('click','.sort_date',function(){
  jQuery(this).find('span').toggleClass('sorting_chevron-down');
  jQuery(this).find('span').toggleClass('sorting_chevron-up');
  sortListDirWithDate();
});

});

jQuery(".site-header .menu-btn").focus(function() {
  jQuery(".site-header .menu-icon").css("border-color", "#e7ab00");
});
jQuery(".site-header .menu-btn").blur(function() {
  jQuery(".site-header .menu-icon").css("border-color", "transparent");
});
